import { graphql } from '@graphql/__generated'

export const SET_BADGE_PRINTED_FOR_ATTENDEE = graphql(`
  mutation setBadgePrintedForAttendee(
    $email: String
    $ticketCode: String
    $eventId: String!
  ) {
    setBadgePrintedForAttendee(
      email: $email
      ticketCode: $ticketCode
      eventId: $eventId
    )
  }
`)
